import { Component, OnInit } from '@angular/core';
import { BlogsModel } from 'src/app/Model/Blogs/blogs.model';
import { BlogsService } from 'src/app/Service/Blogs/blogs.service';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import { RouteHelper } from '../../Constant/routehelper';
import {CustomFormModel} from '../../Model/CustomForm/customFormSave.model'
import {CustomFormComponent} from '../customform/customform.component';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.css']
})
export class BlogsComponent implements OnInit {
  imageFolder:string;
  blogList:BlogsModel;
  IsBlogContentShow:boolean;
  blogData:BlogsModel;
  list:CustomFormModel
  productedsObservable=[];
  Customlist=[];
  id:number;


  constructor(private _BlogService:BlogsService, private router: Router)
   {
    this.imageFolder=environment.imageFolder;
   }

  ngOnInit() {
    this.GetBlogs();

    this.GetSelectedForm(this.id);
  }

  GetBlogs(){
 this._BlogService.GetBlogs().subscribe(
   res=>{
     this.blogList =res.responseData;
   }
 )
  }

  blogShow(_selectedBlog:BlogsModel){
    this.blogData=_selectedBlog;
    this.IsBlogContentShow=true;

  }

  backOnBlog(){
    this.IsBlogContentShow=false;
  }


  GetSelectedForm(id:number){
     var id =3
    this._BlogService.SelectedCustomForm(id).subscribe(
      res=>{
        this.Customlist=res.responseData;
      }
    )   
  }
}
